import type { ChangeEvent } from "react";
import { useRef, useState } from "react";

type FilePickerProps = {
  onFile: (file: File) => void;
  disabled?: boolean;
  currentName?: string;
};

export const FilePicker = ({ onFile, disabled, currentName }: FilePickerProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [hover, setHover] = useState(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) onFile(file);
    e.target.value = "";
  };

  return (
    <div
      className={`dropzone${hover ? " dropzone--hover" : ""}${disabled ? " dropzone--disabled" : ""}`}
      onDragOver={(e) => {
        e.preventDefault();
        if (!disabled) setHover(true);
      }}
      onDragLeave={() => setHover(false)}
      onDrop={(e) => {
        e.preventDefault();
        setHover(false);
        const file = e.dataTransfer.files?.[0];
        if (file && !disabled) onFile(file);
      }}
    >
      <p className="dropzone__title">
        {disabled
          ? `Анализ ${currentName ?? "файла"}…`
          : "Перетащите MIDI-файл сюда или нажмите кнопку"}
      </p>
      <p className="dropzone__hint">Поддерживаются файлы .mid и .midi</p>
      <button
        type="button"
        className="btn btn--primary"
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
      >
        Выбрать файл
      </button>
      <input
        ref={inputRef}
        type="file"
        accept=".mid,.midi,audio/midi,audio/x-midi"
        onChange={onChange}
        style={{ display: "none" }}
      />
    </div>
  );
};
